// extracted by mini-css-extract-plugin
module.exports = {"root":"ContractorHistoryRow_root__2rCMj","cell":"ContractorHistoryRow_cell__IVchL"};